import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  Tooltip,
  IconButton,
  useTheme,
  useMediaQuery
} from "@mui/material";
import {
  useGetPositionQuery,
  useGetlastUpdateDatePayrollQuery,
  useGetSaveEmployeePayrollRecordQuery,
  useGetSaveAnEmployeePayRollAdminQuery,
  useGetSaveAnEmplEachRecordPayRollAdminQuery,
  useGetEmployeePayRollAdminUseEditMutation,
  useGetUserInfoOnyQuery,
} from "../../../Api/attoDeskApi";
import {
  IApiResponse,
  IEmployeePayrollEdit,
  IPayrollSummaryList,
  IPosition,
  IEmployeePunchRecord,
  IBonusAdjustments,
  IPayrollDateRangeList,
  IPayrollEachEmployeDateList,
  IUserAdmin,
} from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import TableViewIcon from "@mui/icons-material/TableView";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate, useParams } from "react-router-dom";
import { Privileges } from "../../../Core/Enum/enum";
import useUser from "../../../Core/hook/useUser";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import ListIcon from "@mui/icons-material/List";
import LogoMain from "../../../Images/logo.webp";
import AddIcon from "@mui/icons-material/Add";
import { useFormik } from "formik";
import { FaTrash } from "react-icons/fa";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Index: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const { id: payrollId } = useParams<{ id: string }>();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const componentRef = useRef<HTMLDivElement>(null);
  const { userHasRight } = useUser();
  const [payrollList, setPayrollList] = useState<IEmployeePayrollEdit[]>([]);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState<IEmployeePayrollEdit | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [selectedEmpId, setSelectedEmpId] = useState<string | undefined>("");
  const [selectedName, setSelectedName] = useState<string | undefined>("");
  const [selectedHrs, setSelectedHrs] = useState<string | undefined>("0.00");
  const [coursingToDelete, setCoursingToDelete] =
    useState<IEmployeePayrollEdit | null>(null);
  const [fieldSums, setFieldSums] = useState({
    hourly_salary: ".00",
    ot_hourly_salary: "0.00",
    total_ot_hours: "0.00",
    total_normal_hours: "0.00",
    total_hours: "0.00",
    gross_salary: "0.00",
    ot_salary: "0.00",
    total_salary: "0.00",
    bonus_amount: "0.00",
  });
  const [selectedRecordDate, setSelectedRecordDate] = useState<
    string | undefined
  >("");

  const {
    data: payrollLastupdateDateData,
    isLoading: payrollLastupdateDateLoading,
  } = useGetlastUpdateDatePayrollQuery();

  const [
    newEmployeeData,
    { isLoading: newEmployeeDataIsLoading, isError: newEmployeeDataIsError },
  ] = useGetEmployeePayRollAdminUseEditMutation();

  const payrollLastupdateDateList = useMemo(() => {
    return Array.isArray(payrollLastupdateDateData?.data)
      ? payrollLastupdateDateData?.data
      : [];
  }, [payrollLastupdateDateData?.data]);

  const lastDatePayroll =
    payrollLastupdateDateList?.length &&
    payrollLastupdateDateList[0].LastUpdateDate
      ? payrollLastupdateDateList[0].LastUpdateDate
      : null;

  useEffect(() => {
    if (lastDatePayroll) {
      const formattedDate = dayjs(lastDatePayroll);
      setSelectedStartDate(formattedDate);
    }
  }, [lastDatePayroll]);

  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | undefined>(
    undefined
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | undefined>(
    undefined
  );
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openOnConfirm, setOnConfirm] = useState<boolean>(false);
  const [openAdminConfim, setOpenAdminConfim] = useState<boolean>(false);
  const [openAdminConfimPayroll, setOpenAdminConfimPayroll] =
    useState<boolean>(false);

  const { data, isLoading, isError, refetch } =
    useGetSaveEmployeePayrollRecordQuery({
      id: String(payrollId),
    });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const {
    data: payRollEachEmployeeData,
    isLoading: payRollEachEmployeeLoading,
    error: payRollEachEmployeeIsError,
  } = useGetSaveAnEmplEachRecordPayRollAdminQuery(
    selectedEmpId && selectedRecordDate
      ? {
          empid: selectedEmpId,
          payrollId: String(payrollId),
          recordDate: String(selectedRecordDate),
        }
      : { empid: "", payrollId: "", recordDate: "" },
    { skip: !selectedEmpId || !selectedRecordDate || !payrollId }
  );

  const {
    data: payRollAnEmployeeData,
    isLoading: payRollAnEmployeeLoading,
    error: payRollAnEmployeeIsError,
  } = useGetSaveAnEmployeePayRollAdminQuery(
    selectedEmpId
      ? {
          empid: selectedEmpId,
          payrollId: String(payrollId),
        }
      : { empid: "", payrollId: "" },
    { skip: !selectedEmpId || !payrollId }
  );

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const payrollSummaryDataList = useMemo(() => {
    return data?.payrollData as IPayrollDateRangeList;
  }, [data?.payrollData]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.user_role_name} - ${user.username}`);
    });
    return map;
  }, [userList]);

  const userMapNew = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.user_role_name}`);
    });
    return map;
  }, [userList]);

  const payrollMessageList = data?.message;
  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const handleDialogConfirm = (confirmed: boolean) => {
    setOnConfirm(true);
    setOpenDialog(false);
  };

  const handleDialogClose = (confirmed: boolean) => {
    setOnConfirm(false);
    setOpenDialog(false);
  };

  const handleDialogCloseAdminConform = (confirmed: boolean) => {
    setOpenAdminConfim(false);
  };

  const handleGeneratePayrollAdminConform = () => {
    setOpenAdminConfimPayroll(true);
  };
  const handleDialogCloseAdminPayrollConform = (confirmed: boolean) => {
    setOpenAdminConfimPayroll(false);
  };

  const coursings: IEmployeePayrollEdit[] = Array.isArray(data?.data)
    ? (data?.data as IEmployeePayrollEdit[])
    : [];

  useEffect(() => {
    setPayrollList(coursings);
  }, [coursings]);

  const handleEditOpen = (row: IEmployeePayrollEdit) => {
    setEditData(row);
    setIsEditDialogOpen(true);
  };

  const handleEditClose = () => {
    setEditData(null);
    setIsEditDialogOpen(false);
  };

  const handleEditSave = () => {
    if (editData) {
      setPayrollList((prev) =>
        prev.map((item) =>
          item.empid === editData.empid ? { ...item, ...editData } : item
        )
      );
      handleEditClose();
    }
  };

  const handleAdjustmentChange = (
    index: number,
    field: keyof IBonusAdjustments,
    value: string | number
  ) => {
    if (editData) {
      const adjustments = [...editData.bonus_adjustments];
      adjustments[index] = { ...adjustments[index], [field]: value };
      handleEditChange("bonus_adjustments", adjustments);
    }
  };

  const addAdjustment = () => {
    if (editData) {
      const newAdjustment: IBonusAdjustments = {
        selector: "add",
        value: 0,
        remark: "",
      };
      handleEditChange("bonus_adjustments", [
        ...(editData.bonus_adjustments || []),
        newAdjustment,
      ]);
    }
  };

  const removeAdjustment = (index: number) => {
    if (editData) {
      const adjustments = [...editData.bonus_adjustments];
      adjustments.splice(index, 1);
      handleEditChange("bonus_adjustments", adjustments);
    }
  };

  useEffect(() => {
    if (editData && !editData.bonus_adjustments) {
      handleEditChange("bonus_adjustments", []);
    }
  }, [editData]);

  useEffect(() => {
    if (payrollList.length > 0) {
      setFieldSums(calculateSums(payrollList));
    }
  }, [payrollList]);

  const handleEditChange = (
    field: keyof IEmployeePayrollEdit,
    value: string | number | IBonusAdjustments[]
  ) => {
    if (editData) {
      let updatedData = { ...editData, [field]: value };

      if (field !== "bonus_adjustments") {
        const totalNormalHours = parseFloat(
          String(updatedData.total_normal_hours || 0)
        );
        const hourlySalary = parseFloat(String(updatedData.hourly_salary || 0));
        const totalOtHours = parseFloat(
          String(updatedData.total_ot_hours || 0)
        );
        const otHourlySalary = parseFloat(
          String(updatedData.ot_hourly_salary || 0)
        );

        const bonusAmount = parseFloat(String(updatedData.bonus_amount || 0));

        const totalSalary =
          totalNormalHours * hourlySalary +
          totalOtHours * otHourlySalary +
          bonusAmount;

        const grossSalary = totalNormalHours * hourlySalary;

        const otSalary = totalOtHours * otHourlySalary;

        const totalHours = totalOtHours + totalNormalHours;

        updatedData.total_salary = totalSalary;
        updatedData.gross_salary = grossSalary;
        updatedData.ot_salary = otSalary;
        updatedData.total_hours = totalHours;
      }

      if (field === "bonus_adjustments" && Array.isArray(value)) {
        const adjustmentSalary = value.reduce((sum, adjustment) => {
          const amount = adjustment.value || 0;
          const actionType = adjustment.selector;
          return sum + (actionType === "add" ? amount : -amount);
        }, 0);

        updatedData.bonus_amount = adjustmentSalary;

        const totalNormalHours = parseFloat(
          String(updatedData.total_normal_hours || 0)
        );
        const hourlySalary = parseFloat(String(updatedData.hourly_salary || 0));
        const totalOtHours = parseFloat(
          String(updatedData.total_ot_hours || 0)
        );
        const otHourlySalary = parseFloat(
          String(updatedData.ot_hourly_salary || 0)
        );

        updatedData.total_salary =
          totalNormalHours * hourlySalary +
          totalOtHours * otHourlySalary +
          adjustmentSalary;
      }

      updatedData.is_Edited_payroll = true;
      updatedData.is_Edited = true;


      setEditData(updatedData);
    }
  };

  const EmployeePunchRecord: IEmployeePunchRecord[] = Array.isArray(
    payRollAnEmployeeData?.data
  )
    ? (payRollAnEmployeeData?.data as IEmployeePunchRecord[])
    : [];

  const EmpEachPunchRecord: IPayrollEachEmployeDateList[] = Array.isArray(
    payRollEachEmployeeData?.data
  )
    ? (payRollEachEmployeeData?.data as IPayrollEachEmployeDateList[])
    : [];

  const handleViewClick = (
    empid: string,
    employee_name: string,
    hourly_salary: string,
    coursing: IEmployeePayrollEdit
  ) => {
    setSelectedEmpId(empid);
    setSelectedName(employee_name);
    setSelectedHrs(hourly_salary);
    setCoursingToDelete(coursing);
    setOpen(true);
  };

  const handleDateViewClick = (recordDate: string) => {
    setSelectedRecordDate(recordDate);
    setOpenAdminConfim(true);
  };

  const formik = useFormik({
    initialValues: {
      payrollList: [],
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          payrollList: payrollList,
          total_salary: fieldSums.total_salary,
          bonus_amount: fieldSums.bonus_amount,
          payrollId: payrollId,
        };

        const addCompanyResponse = await newEmployeeData(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          setOpenAdminConfimPayroll(false);
          // navigate("/payroll/list");
          navigate(`/payroll/list/${payrollId}`);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });
  const calculateSums = (data: IEmployeePayrollEdit[]) => {
    const initialSums = {
      hourly_salary: 0,
      ot_hourly_salary: 0,
      total_ot_hours: 0,
      total_normal_hours: 0,
      total_hours: 0,
      gross_salary: 0,
      ot_salary: 0,
      total_salary: 0,
      bonus_amount: 0,
    };

    const sums = data.reduce((acc, row) => {
      acc.hourly_salary += parseFloat(row.hourly_salary as any) || 0;
      acc.ot_hourly_salary += parseFloat(row.ot_hourly_salary as any) || 0;
      acc.total_ot_hours += parseFloat(row.total_ot_hours as any) || 0; // Convert here
      acc.total_normal_hours += parseFloat(row.total_normal_hours as any) || 0;
      acc.total_hours += parseFloat(row.total_hours as any) || 0;
      acc.gross_salary += parseFloat(row.gross_salary as any) || 0;
      acc.ot_salary += parseFloat(row.ot_salary as any) || 0;
      acc.total_salary += parseFloat(row.total_salary as any) || 0;
      acc.bonus_amount += parseFloat(row.bonus_amount as any) || 0;
      return acc;
    }, initialSums);

    // const sums = data.reduce((acc, row) => {
    //   if (row.isConformToGeneratePayroll) {
    //     acc.hourly_salary += parseFloat(row.hourly_salary as any) || 0;
    //     acc.ot_hourly_salary += parseFloat(row.ot_hourly_salary as any) || 0;
    //     acc.total_ot_hours += row.total_ot_hours || 0;
    //     acc.total_normal_hours += row.total_normal_hours || 0;
    //     acc.total_hours += row.total_hours || 0;
    //     acc.gross_salary += row.gross_salary || 0;
    //     acc.ot_salary += row.ot_salary || 0;
    //     acc.total_salary += row.total_salary || 0;
    //     acc.bonus_amount += row.bonus_amount || 0;
    //   }
    //   return acc;
    // }, initialSums);

    return {
      hourly_salary: Number(sums.hourly_salary).toFixed(2),
      ot_hourly_salary: Number(sums.ot_hourly_salary).toFixed(2),
      total_ot_hours: Number(sums.total_ot_hours).toFixed(2),
      total_normal_hours: Number(sums.total_normal_hours).toFixed(2),
      total_hours: Number(sums.total_hours).toFixed(2),
      gross_salary: Number(sums.gross_salary).toFixed(2),
      ot_salary: Number(sums.ot_salary).toFixed(2),
      total_salary: Number(sums.total_salary).toFixed(2),
      bonus_amount: Number(sums.bonus_amount).toFixed(2),
    };
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedEmpId(undefined);
    setSelectedName(undefined);
    setSelectedHrs(undefined);
    setCoursingToDelete(null);
  };

  const handleExportToExcel = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const exportData = payrollList.map((row, index) => ({
      "Employee Name": row.employee_name,
      Position: postionMap.get(row.employee_position_id) || "",
      "Normal Hours": getSafeToFixed(row.total_normal_hours),
      "Hourly Salary": getSafeToFixed(row.hourly_salary),
      "Overtime Hours":
        row.total_ot_hours === null ||
        isNaN(parseFloat(String(row.total_ot_hours)))
          ? ""
          : parseFloat(String(row.total_ot_hours)) === 0
          ? "-"
          : parseFloat(String(row.total_ot_hours)).toFixed(2),
      "Overtime Hourly Salary":
        row.total_ot_hours !== null &&
        !isNaN(parseFloat(String(row.total_ot_hours))) &&
        parseFloat(String(row.total_ot_hours)) > 0
          ? row.ot_hourly_salary !== null &&
            !isNaN(parseFloat(String(row.ot_hourly_salary)))
            ? parseFloat(String(row.ot_hourly_salary)).toFixed(2)
            : "-"
          : "-",
      "Gross Salary": getSafeToFixed(row.gross_salary),
      //"OT Salary": getSafeToFixed(row.ot_salary),
      "OT Salary":
        row.ot_salary !== null &&
        !isNaN(parseFloat(String(row.ot_salary))) &&
        parseFloat(String(row.ot_salary)) > 0
          ? row.ot_salary !== null && !isNaN(parseFloat(String(row.ot_salary)))
            ? parseFloat(String(row.ot_salary)).toFixed(2)
            : "-"
          : "-",

      // "Adjustment Amount": getSafeToFixed(row.bonus_amount),
      "Adjustment Amount":
        row.bonus_amount !== null &&
        !isNaN(parseFloat(String(row.bonus_amount))) &&
        parseFloat(String(row.bonus_amount)) > 0
          ? row.bonus_amount !== null &&
            !isNaN(parseFloat(String(row.bonus_amount)))
            ? parseFloat(String(row.bonus_amount)).toFixed(2)
            : "-"
          : "-",
      "Total Amount": getSafeToFixed(row.total_salary),
    }));

    exportData.push({
      "Employee Name": "",
      Position: "",
      "Normal Hours": getSafeToFixed(payrollSummaryDataList.total_normal_hours),
      "Hourly Salary": "",
      "Overtime Hours": getSafeToFixed(payrollSummaryDataList.total_ot_hours),
      "Overtime Hourly Salary": "",
      "Gross Salary": getSafeToFixed(payrollSummaryDataList.gross_salary),
      "OT Salary": getSafeToFixed(payrollSummaryDataList.ot_salary),
      "Adjustment Amount": getSafeToFixed(payrollSummaryDataList.bonus_amount),
      "Total Amount": getSafeToFixed(payrollSummaryDataList.total_salary),
    });

    const StartDate = payrollSummaryDataList?.startDate
      ? dayjs(payrollSummaryDataList.startDate).format("MMM-DD, YYYY")
      : " ";

    const EndDate = payrollSummaryDataList?.endDate
      ? dayjs(payrollSummaryDataList.endDate).format("MMM-DD, YYYY")
      : " ";

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "payroll");
    const fileName = `PayrollList_${StartDate}_to_${EndDate}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    const getSafeToFixed = (
      value: string | number | null | undefined
    ): string => {
      const numericValue = parseFloat(String(value));
      return !isNaN(numericValue) ? numericValue.toFixed(2) : "";
    };

    const tableData = payrollList.map((row, index) => [
      row.employee_name,
      postionMap.get(row.employee_position_id) || "",
      getSafeToFixed(row.total_normal_hours),
      getSafeToFixed(row.hourly_salary),
      row.total_ot_hours === null ||
      isNaN(parseFloat(String(row.total_ot_hours)))
        ? ""
        : parseFloat(String(row.total_ot_hours)) === 0
        ? "-"
        : parseFloat(String(row.total_ot_hours)).toFixed(2),
      row.total_ot_hours !== null &&
      !isNaN(parseFloat(String(row.total_ot_hours))) &&
      parseFloat(String(row.total_ot_hours)) > 0
        ? row.ot_hourly_salary !== null &&
          !isNaN(parseFloat(String(row.ot_hourly_salary)))
          ? parseFloat(String(row.ot_hourly_salary)).toFixed(2)
          : "-"
        : "-",
      getSafeToFixed(row.gross_salary),
      // getSafeToFixed(row.ot_salary),

      row.ot_salary !== null &&
      !isNaN(parseFloat(String(row.ot_salary))) &&
      parseFloat(String(row.ot_salary)) > 0
        ? row.ot_salary !== null && !isNaN(parseFloat(String(row.ot_salary)))
          ? parseFloat(String(row.ot_salary)).toFixed(2)
          : "-"
        : "-",
      // getSafeToFixed(row.bonus_amount),

      row.bonus_amount !== null &&
      !isNaN(parseFloat(String(row.bonus_amount))) &&
      parseFloat(String(row.bonus_amount)) > 0
        ? row.bonus_amount !== null &&
          !isNaN(parseFloat(String(row.bonus_amount)))
          ? parseFloat(String(row.bonus_amount)).toFixed(2)
          : "-"
        : "-",
      getSafeToFixed(row.total_salary),
    ]);

    tableData.push([
      "Total",
      "",
      getSafeToFixed(payrollSummaryDataList.total_normal_hours),
      "",
      getSafeToFixed(payrollSummaryDataList.total_ot_hours),
      "",
      getSafeToFixed(payrollSummaryDataList.gross_salary),
      getSafeToFixed(payrollSummaryDataList.ot_salary),
      getSafeToFixed(payrollSummaryDataList.bonus_amount),
      getSafeToFixed(payrollSummaryDataList.total_salary),
    ]);

    const tableHeaders = [
      [
        "Employee Name",
        "Position",
        "Normal Hours",
        "Hourly Salary",
        "OT Hours",
        "OT Hourly Salary",
        "Gross Salary",
        "OT Salary",
        "Adjustment Amount",
        "Total Amount",
      ],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");

    const StartDate = payrollSummaryDataList?.startDate
      ? dayjs(payrollSummaryDataList.startDate).format("MMM-DD, YYYY")
      : " ";

    const EndDate = payrollSummaryDataList?.endDate
      ? dayjs(payrollSummaryDataList.endDate).format("MMM-DD, YYYY")
      : " ";

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = 50;
    const imgHeight = 12;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);
      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      rightAlignText(`Payroll Summary Report`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Period: ${StartDate} to ${EndDate}`, textStartY + 5);

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `PayrollList_${StartDate}_to_${EndDate}.pdf`;

      doc.save(fileName);
    };
  };

  const handleExportToPDFForEmployeePunch = () => {
    const tableData = EmployeePunchRecord.map((row, index) => [
      dayjs(row.recordDate).format("YYYY-MM-DD"),
      row.punchDetails.length > 0
      ? row.punchDetails
          .map((punchDetail) => {
            const inTime = formatTime(punchDetail.punch_in_time);
            const outTime = punchDetail.punch_out_time
              ? punchDetail.punch_in_date !== punchDetail.punch_out_date
                ? `${dayjs(punchDetail.punch_out_date).format(
                    "MMM-DD, YYYY"
                  )} ${formatTime(punchDetail.punch_out_time)}`
                : formatTime(punchDetail.punch_out_time)
              : "Pending";

            return `${inTime} - ${outTime}`;
          })
          .join(", ")
      : "",
      row.break_hours === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(row.break_hours))) ||
      isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours)) ===
          0
        ? "-"
        : `${(
            parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours))
          ).toFixed(2)} hrs`,
      row.break_hours === null || isNaN(parseFloat(String(row.break_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.break_hours)).toFixed(2)} hrs`,
      row.total_hours === null || isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.total_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.total_hours)).toFixed(2)} hrs`,
      selectedHrs === null || isNaN(parseFloat(String(selectedHrs)))
        ? ""
        : parseFloat(String(selectedHrs)) === 0
        ? "-"
        : `$ ${parseFloat(String(selectedHrs)).toFixed(2)}`,
      selectedHrs === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(selectedHrs)) * row.total_hours)
        ? ""
        : parseFloat(String(selectedHrs)) * row.total_hours === 0
        ? "-"
        : `$ ${(parseFloat(String(selectedHrs)) * row.total_hours).toFixed(2)}`,
    ]);

    tableData.push([
      "",
      "",
      "",
      coursingToDelete &&
      coursingToDelete.total_break_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_break_hours)))
        ? parseFloat(String(coursingToDelete.total_break_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_break_hours)).toFixed(
              2
            )} hrs`
        : "",
      coursingToDelete &&
      coursingToDelete.total_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_hours)))
        ? parseFloat(String(coursingToDelete.total_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_hours)).toFixed(2)} hrs`
        : "",
      "",
      coursingToDelete &&
      coursingToDelete.gross_salary !== null &&
      !isNaN(parseFloat(String(coursingToDelete.gross_salary)))
        ? parseFloat(String(coursingToDelete.gross_salary)) === 0
          ? "-"
          : `$ ${parseFloat(String(coursingToDelete.gross_salary)).toFixed(2)}`
        : "",
    ]);

    const tableHeaders = [
      [
        "Date",
        "Records",
        "Actual Hours",
        "Total Break Hours",
        "Total working hours",
        "Hourly Salary",
        "Total Amount",
      ],
    ];

    const StartDate = payrollSummaryDataList?.startDate
      ? dayjs(payrollSummaryDataList.startDate).format("MMM DD YYYY")
      : " ";

    const EndDate = payrollSummaryDataList?.endDate
      ? dayjs(payrollSummaryDataList.endDate).format("MMM DD YYYY")
      : " ";

    const doc = new jsPDF("l", "mm", "a4");

    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = 50;
    const imgHeight = 15;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Payroll Summary - ${selectedName}`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Period: ${StartDate} to ${EndDate}`, textStartY + 5);

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `PayrollSummary_${StartDate}_to_${EndDate}_${selectedName}.pdf`;

      doc.save(fileName);
    };
  };

  const handleEmployeePunchExcel = () => {
    const tableData = EmployeePunchRecord.map((row, index) => [
      dayjs(row.recordDate).format("YYYY-MM-DD"),
      row.punchDetails.length > 0
        ? row.punchDetails
            .map((punchDetail) => {
              const inTime = formatTime(punchDetail.punch_in_time);
              const outTime = punchDetail.punch_out_time
                ? punchDetail.punch_in_date !== punchDetail.punch_out_date
                  ? `${dayjs(punchDetail.punch_out_date).format(
                      "MMM-DD, YYYY"
                    )} ${formatTime(punchDetail.punch_out_time)}`
                  : formatTime(punchDetail.punch_out_time)
                : "Pending";

              return `${inTime} - ${outTime}`;
            })
            .join(", ")
        : "",
      row.break_hours === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(row.break_hours))) ||
      isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours)) ===
          0
        ? "-"
        : `${(
            parseFloat(String(row.break_hours)) +
            parseFloat(String(row.total_hours))
          ).toFixed(2)} hrs`,
      row.break_hours === null || isNaN(parseFloat(String(row.break_hours)))
        ? ""
        : parseFloat(String(row.break_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.break_hours)).toFixed(2)} hrs`,
      row.total_hours === null || isNaN(parseFloat(String(row.total_hours)))
        ? ""
        : parseFloat(String(row.total_hours)) === 0
        ? "-"
        : `${parseFloat(String(row.total_hours)).toFixed(2)} hrs`,
      selectedHrs === null || isNaN(parseFloat(String(selectedHrs)))
        ? ""
        : parseFloat(String(selectedHrs)) === 0
        ? "-"
        : `$ ${parseFloat(String(selectedHrs)).toFixed(2)}`,
      selectedHrs === null ||
      row.total_hours === null ||
      isNaN(parseFloat(String(selectedHrs)) * row.total_hours)
        ? ""
        : parseFloat(String(selectedHrs)) * row.total_hours === 0
        ? "-"
        : `$ ${(parseFloat(String(selectedHrs)) * row.total_hours).toFixed(2)}`,
    ]);

    tableData.push([
      "",
      "",
      "",
      coursingToDelete &&
      coursingToDelete.total_break_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_break_hours)))
        ? parseFloat(String(coursingToDelete.total_break_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_break_hours)).toFixed(
              2
            )} hrs`
        : "",
      coursingToDelete &&
      coursingToDelete.total_hours !== null &&
      !isNaN(parseFloat(String(coursingToDelete.total_hours)))
        ? parseFloat(String(coursingToDelete.total_hours)) === 0
          ? "-"
          : `${parseFloat(String(coursingToDelete.total_hours)).toFixed(2)} hrs`
        : "",
      "",
      coursingToDelete &&
      coursingToDelete.gross_salary !== null &&
      !isNaN(parseFloat(String(coursingToDelete.gross_salary)))
        ? parseFloat(String(coursingToDelete.gross_salary)) === 0
          ? "-"
          : `$ ${parseFloat(String(coursingToDelete.gross_salary)).toFixed(2)}`
        : "",
    ]);

    const tableHeaders = [
      [
        "Date",
        "Records",
        "Actual Hours",
        "Total Break Hours",
        "Total working hours",
        "Hourly Salary",
        "Total Amount",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders[0], ...tableData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ClockIn_OutList");
    const StartDate = payrollSummaryDataList?.startDate
      ? dayjs(payrollSummaryDataList.startDate).format("MMM-DD-YYYY")
      : " ";

    const EndDate = payrollSummaryDataList?.endDate
      ? dayjs(payrollSummaryDataList.endDate).format("MMM-DD-YYYY")
      : " ";

    const fileName = `PayrollSummary_${StartDate}_to_${EndDate}_${selectedName}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleDialogAdminConform = (confirmed: boolean) => {
    formik.handleSubmit();
  };

  return (
    <div>
      <Card className={classes.quotesCard}>
        <Grid container spacing={1} padding={isMobile ? "1px" : 2}>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className={classes.titleGrid}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={3}>
                  <Grid
                    item
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className={classes.titleGrid}
                  >
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="start">
                          <Grid item lg={2} md={4} sm={4} xs={4}>
                            <Typography>
                              <strong>Start Date :</strong>{" "}
                            </Typography>
                          </Grid>

                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography>
                              {payrollSummaryDataList?.startDate
                                ? dayjs(
                                    payrollSummaryDataList.startDate
                                  ).format("MMM-DD, YYYY")
                                : " "}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container alignItems="start">
                          <Grid item lg={2} md={4} sm={4} xs={4}>
                            <Typography>
                              <strong>End Date :</strong>{" "}
                            </Typography>
                          </Grid>
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography>
                              {payrollSummaryDataList?.endDate
                                ? dayjs(payrollSummaryDataList.endDate).format(
                                    "MMM-DD, YYYY"
                                  )
                                : " "}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                        <Button
                          startIcon={<TableViewIcon />}
                          className={classes.addButtonPdfExcel}
                          onClick={handleExportToExcel}
                        >
                          Excel
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          startIcon={<LocalPrintshopSharpIcon />}
                          className={classes.addButtonPdfExcel}
                          onClick={handleExportToPDF}
                        >
                          pdf
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{ paddingBottom: 5 }}
            className={classes.titleGrid}
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div ref={componentRef}>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                          <TableCell className={classes.tablheaderId}>
                            <strong>#</strong>
                          </TableCell>
                          <TableCell className={classes.tablheaderPayroll}>
                            <strong>Employee Name</strong>
                          </TableCell>
                          <TableCell className={classes.tablheaderPayroll}>
                            <strong>Position</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheaderPayroll}
                            sx={{ textAlign: "right", width: "10%" }}
                          >
                            <strong>Normal Working Hours</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheaderPayroll}
                            sx={{ textAlign: "right", width: "10%" }}
                          >
                            <strong>Wrk Hourly Salary</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheaderPayroll}
                            sx={{ textAlign: "right", width: "10%" }}
                          >
                            <strong>OT Hours</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheaderPayroll}
                            sx={{ textAlign: "right", width: "10%" }}
                          >
                            <strong>OT Hourly Salary</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheaderPayroll}
                            sx={{ textAlign: "right", width: "10%" }}
                          >
                            <strong>Adjustment Amount</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheaderPayroll}
                            sx={{ textAlign: "right", width: "10%" }}
                          >
                            <strong>Total Salary</strong>
                          </TableCell>
                          {userHasRight(
                            Privileges.GeneratePayroll || Privileges.PayrollView
                          ) && (
                            <TableCell
                              className={classes.tablheaderPayroll}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {isLoading || positionLoading ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="10vh"
                              >
                                <CircularProgress />
                              </Box>
                            </TableCell>
                          </TableRow>
                        ) : isError ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {isError
                                ? payrollMessageList ||
                                  "Some thing went to wrong"
                                : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : coursings.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              No data available
                            </TableCell>
                          </TableRow>
                        ) : (
                          payrollList.map((row: IEmployeePayrollEdit, index) => (
                            <TableRow
                              key={index}
                              className={classes.tableRowHover}
                              // sx={{
                              //   backgroundColor: row.isPreviousPaymentPaid
                              //     ? "#f79aa61c"
                              //     : "transparent",
                              // }}
                            >
                              <TableCell
                                scope="row"
                                className={classes.tablCellId}
                              >
                                {page * rowsPerPage + index + 1}
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCellPayroll}
                              >
                                {row.employee_name}
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCellPayroll}
                              >
                                {postionMap.get(row.employee_position_id) || ""}
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCellPayroll}
                                sx={{ textAlign: "right" }}
                              >
                                {row.total_normal_hours === null ||
                                isNaN(
                                  parseFloat(String(row.total_normal_hours))
                                )
                                  ? ""
                                  : parseFloat(
                                      String(row.total_normal_hours)
                                    ).toFixed(2)}
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCellPayroll}
                                sx={{ textAlign: "right" }}
                              >
                                {row.hourly_salary === null ||
                                isNaN(parseFloat(String(row.hourly_salary)))
                                  ? ""
                                  : parseFloat(
                                      String(row.hourly_salary)
                                    ).toFixed(2)}
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCellPayroll}
                                sx={{ textAlign: "right" }}
                              >
                                {row.total_ot_hours === null ||
                                isNaN(parseFloat(String(row.total_ot_hours)))
                                  ? ""
                                  : parseFloat(String(row.total_ot_hours)) === 0
                                  ? "-"
                                  : parseFloat(
                                      String(row.total_ot_hours)
                                    ).toFixed(2)}
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCellPayroll}
                                sx={{ textAlign: "right" }}
                              >
                                {/* {row.ot_hourly_salary === null ||
                                isNaN(parseFloat(String(row.ot_hourly_salary)))
                                  ? ""
                                  : parseFloat(String(row.ot_hourly_salary)) ===
                                    0
                                  ? "-"
                                  : parseFloat(
                                      String(row.ot_hourly_salary)
                                    ).toFixed(2)} */}
                                {row.total_ot_hours !== null &&
                                !isNaN(
                                  parseFloat(String(row.total_ot_hours))
                                ) &&
                                parseFloat(String(row.total_ot_hours)) > 0
                                  ? row.ot_hourly_salary !== null &&
                                    !isNaN(
                                      parseFloat(String(row.ot_hourly_salary))
                                    )
                                    ? parseFloat(
                                        String(row.ot_hourly_salary)
                                      ).toFixed(2)
                                    : "-"
                                  : "-"}
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCellPayroll}
                                sx={{ textAlign: "right" }}
                              >
                                <Tooltip
                                  title={
                                    row.bonus_adjustments?.length > 0 ||
                                    row.edited_by ? (
                                      <>
                                        {row.bonus_adjustments?.map(
                                          (adjustment, index) => (
                                            <Typography
                                              variant="body2"
                                              key={index}
                                            >
                                              <strong>
                                                {adjustment.remark}
                                              </strong>{" "}
                                              : {adjustment.value}
                                            </Typography>
                                          )
                                        )}

                                        {row.edited_by && (
                                          <>
                                            <Typography
                                              textAlign="right"
                                              mt={2}
                                            >
                                              {userMap.get(row.edited_by) || ""}
                                            </Typography>
                                            {row.edited_at && (
                                              <Typography textAlign="right">
                                                {"( "}
                                                {dayjs(row.edited_at).isValid()
                                                  ? dayjs(row.edited_at).format(
                                                      "YYYY-MM-DD hh:mm A"
                                                    )
                                                  : ""}
                                                {" )"}
                                              </Typography>
                                            )}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )
                                  }
                                  sx={{ fontSize: "14px" }}
                                >
                                  <span
                                    style={{
                                      cursor:
                                        row.bonus_adjustments?.length > 0 || row.edited_by
                                          ? "pointer"
                                          : "default",
                                    }}
                                  >
                                    {row.bonus_amount == null ||
                                    isNaN(Number(row.bonus_amount))
                                      ? ""
                                      : Number(row.bonus_amount) === 0
                                      ? "-"
                                      : Number(row.bonus_amount).toFixed(2)}

                                    {row.edited_by && (
                                      <Typography
                                        textAlign="right"
                                        sx={{ fontSize: "12px" }}
                                      >
                                        {userMapNew.get(row.edited_by)}
                                      </Typography>
                                    )}
                                  </span>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCellPayroll}
                                sx={{ textAlign: "right" }}
                              >
                                {row.gross_salary === null ||
                                isNaN(parseFloat(String(row.total_salary)))
                                  ? ""
                                  : parseFloat(
                                      String(row.total_salary)
                                    ).toFixed(2)}
                              </TableCell>
                              {userHasRight(
                                Privileges.GeneratePayroll ||
                                  Privileges.PayrollView
                              ) && (
                                <TableCell className={classes.tablCellPayroll}>
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    {" "}
                                    <Tooltip
                                      title={
                                        <>
                                          <Typography
                                            variant="body2"
                                            key={index}
                                          >
                                            <strong>View All</strong>
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            key={index}
                                          >
                                            <strong>
                                              Punch Details Records
                                            </strong>
                                          </Typography>
                                        </>
                                      }
                                      sx={{ fontSize: "14px" }}
                                    >
                                      <Grid item>
                                        <Button
                                          // variant="contained"
                                          className={classes.editButtonList}
                                          onClick={() =>
                                            handleViewClick(
                                              String(row.empid),
                                              String(row.employee_name),
                                              String(row.hourly_salary),
                                              row
                                            )
                                          }
                                        >
                                          <ListIcon
                                            className={
                                              classes.deleteListIcon
                                            }
                                          />
                                        </Button>
                                      </Grid>
                                    </Tooltip>
                                    <Tooltip
                                      title={
                                        <>
                                          <Typography
                                            variant="body2"
                                            key={index}
                                          >
                                            <strong>
                                              View Adjustment Amount
                                            </strong>
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            key={index}
                                          >
                                            <strong>&& Edited Details</strong>
                                          </Typography>
                                        </>
                                      }
                                      sx={{ fontSize: "14px" }}
                                    >
                                      <Grid item>
                                        <Button
                                          // variant="contained"
                                          className={classes.viewButtonList}
                                          onClick={() => handleEditOpen(row)}
                                        >
                                          <VisibilitySharpIcon
                                            className={
                                              classes.viewListIcon
                                            }
                                          />
                                        </Button>
                                      </Grid>
                                    </Tooltip>
                                  </Grid>
                                </TableCell>
                              )}
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6}></Grid>

                  <Grid
                    item
                    lg={6}
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.cardGreenBAckGroundColor}
                  >
                    <Grid container spacing={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              Total Normal Hours :
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                            paddingRight={2}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              {Number(
                                fieldSums.total_normal_hours || 0
                              ).toFixed(2)}
                              {" hrs"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              Total OT Hours :
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                            paddingRight={2}
                            pb={2}
                            borderBottom={0.5}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              {Number(fieldSums.total_ot_hours || 0).toFixed(2)}
                              {" hrs"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12} py={1}>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <Typography className={classes.h4}>
                              Total Hours :
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                            paddingRight={2}
                          >
                            <Typography className={classes.h4}>
                              {Number(fieldSums.total_hours || 0).toFixed(2)}
                              {" hrs"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6}></Grid>

                  <Grid
                    item
                    lg={6}
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.cardGreenBAckGroundColor}
                  >
                    <Grid container spacing={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              Total Normal Working Salary :
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                            paddingRight={2}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              {"$ "}
                              {Number(fieldSums.gross_salary).toFixed(2)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              Total OT Salary :
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                            paddingRight={2}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              {"$ "}
                              {Number(fieldSums.ot_salary || 0).toFixed(2)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              Total Adjustment Amount :
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                            paddingRight={2}
                            pb={1}
                            borderBottom={0.5}
                          >
                            <Typography className={classes.cardGreenTypograpy}>
                              {"$ "}
                              {Number(fieldSums.bonus_amount || 0).toFixed(2)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12} py={2}>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            lg={8}
                            md={8}
                            sm={8}
                            xs={8}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              alignItems: "center",
                            }}
                          >
                            <Typography className={classes.h4}>
                              Total Amount
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            lg={4}
                            md={4}
                            sm={4}
                            xs={4}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                            paddingRight={2}
                          >
                            <Typography className={classes.h4}>
                              {"$ "}
                              {Number(fieldSums.total_salary || 0).toFixed(2)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{ paddingBottom: 5 }}
            className={classes.titleGrid}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {userHasRight(Privileges.GeneratePayroll) && (
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="contained"
                    startIcon={<CheckCircleOutlineIcon />}
                    className={classes.addButton}
                    onClick={handleGeneratePayrollAdminConform}
                  >
                    Confirm
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Card>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        sx={{ padding: 5, minWidth: 450 }}
      >
        <Grid className={classes.Dialog}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              pt={2}
              alignContent={"center"}
            >
              <Typography className={classes.cardTitle}>
                Generate Payroll for selected dates
              </Typography>
            </Grid>
          </Grid>
          <DialogContent>
            <DialogContentText sx={{ pt: 3 }}>
              <Typography className={classes.bodyDialog} pb={2}>
                Are you sure you want to generate payroll for the selected
                dates?
              </Typography>
              <Typography textAlign={"center"} className={classes.body2}>
                <strong>Start Date :</strong>
                {"  "}
                {selectedStartDate?.format("MMM-DD, YYYY") || " "}
              </Typography>
              <Typography textAlign={"center"} className={classes.body2}>
                <strong>End Date :</strong>
                {"  "}
                {selectedEndDate?.format("MMM-DD, YYYY") || " "}
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              className={classes.addButton}
              onClick={() => handleDialogClose(false)}
            >
              Cancel
            </Button>
            <Box m={0.5}></Box>

            <Button
              onClick={() => handleDialogConfirm(true)}
              variant="contained"
              startIcon={<CheckCircleOutlineIcon />}
              className={classes.addButton}
            >
              Confirm
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>

      <Dialog
        open={isEditDialogOpen}
        onClose={handleEditClose}
        aria-describedby="alert-dialog-description"
        classes={{ paper: "inherit" }}
        fullScreen={isMobile}
        fullWidth={isMobile}
        maxWidth="lg"
      >
        <Grid className={classes.Dialog}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
              <Card className={classes.stepperCard}>
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12} pb={3}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        className={classes.titleGridBottomBoredr}
                      >
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, py: 2, px: 5 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Typography className={classes.cardTitle}>
                              Payroll Details ({editData?.employee_name || ""})
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid container>
                          <Grid item lg={6} md={12} sm={12} xs={12}>
                            <Grid
                              container
                              justifyContent={"space-between"}
                              sx={{ py: 2, px: 5 }}
                              spacing={2}
                            >
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className={classes.backgroundColorView2}
                                sx={{ pt: 3, px: 3 }}
                              >
                                <Grid container>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      <span className={classes.customerDetails}>
                                        Normal Working Hours
                                      </span>{" "}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography
                                      className={classes.staffTypograpy}
                                    >
                                      {editData?.total_normal_hours || "0.00"}
                                      {" hrs"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className={classes.backgroundColorView2}
                                sx={{ pb: 3, px: 3 }}
                              >
                                <Grid container>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      <span className={classes.customerDetails}>
                                        Wrk Hourly Salary
                                      </span>{" "}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography
                                      className={classes.staffTypograpy}
                                    >
                                      {"$ "} {editData?.hourly_salary || "0.00"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={6} md={12} sm={12} xs={12}>
                            <Grid
                              container
                              justifyContent={"space-between"}
                              sx={{ py: 2, px: 5 }}
                              spacing={2}
                            >
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className={classes.backgroundColorView2}
                                sx={{ pt: 3, px: 3 }}
                              >
                                <Grid container>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      <span className={classes.customerDetails}>
                                        OT Hours
                                      </span>{" "}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography
                                      className={classes.staffTypograpy}
                                    >
                                      {editData?.total_ot_hours || "0.00"}
                                      {" hrs"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className={classes.backgroundColorView2}
                                sx={{ pb: 3, px: 3 }}
                              >
                                <Grid container>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant="subtitle1">
                                      <span className={classes.customerDetails}>
                                        OT Hourly Salary
                                      </span>{" "}
                                    </Typography>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography
                                      className={classes.staffTypograpy}
                                    >
                                      {"$ "}
                                      {editData?.ot_hourly_salary || "0.00"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* {editData && editData.bonus_adjustments.length > 0 && ( */}
                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          sx={{ py: 2, px: 5 }}
                          spacing={2}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.backgroundColorView2}
                            sx={{ py: 3, px: 3, minHeight: "150px" }}
                          >
                            <Grid
                              container
                              direction="row"
                              alignItems="center"
                              spacing={2}
                              paddingTop={5}
                            >
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <TableContainer>
                                  <Table className={classes.table}>
                                    <TableHead
                                      className={classes.tableHeaderRow}
                                    >
                                      <TableRow>
                                        <TableCell
                                          className={classes.tablheaderPayroll}
                                          sx={{ width: "50%" }}
                                        >
                                          <strong>Remark</strong>
                                        </TableCell>
                                        <TableCell
                                          className={classes.tablheaderPayroll}
                                          sx={{ width: "20%" }}
                                        >
                                          <strong>Action</strong>
                                        </TableCell>
                                        <TableCell
                                          className={classes.tablheaderPayroll}
                                          sx={{ width: "25%" }}
                                        >
                                          <strong>Amount</strong>
                                        </TableCell>
                                        <TableCell
                                          className={classes.tablheaderPayroll}
                                          sx={{ width: "5%" }}
                                        >
                                          <strong></strong>
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {editData?.bonus_adjustments.map(
                                        (adjustment, index) => (
                                          <TableRow
                                            key={index}
                                            className={classes.tableRowHover}
                                          >
                                            <TableCell
                                              scope="row"
                                              sx={{ width: "50%" }}
                                              className={classes.tablCellPayroll}
                                            >
                                              <TextField
                                                placeholder="Remark"
                                                size="small"
                                                value={adjustment.remark}
                                                onChange={(e) =>
                                                  handleAdjustmentChange(
                                                    index,
                                                    "remark",
                                                    e.target.value
                                                  )
                                                }
                                                className={classes.textField}
                                                InputProps={{
                                                  // readOnly: true,
                                                  sx: {
                                                    fontSize: 14,
                                                    border: "none",
                                                  },
                                                  classes: {
                                                    root: classes.textFieldQuoteNoBorder,
                                                    notchedOutline:
                                                      classes.notchedOutline,
                                                  },
                                                }}
                                                InputLabelProps={{
                                                  sx: {
                                                    fontSize: 14,
                                                    border: "none",
                                                  },
                                                }}
                                              />
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              sx={{ width: "20%" }}
                                              className={classes.tablCellPayroll}
                                            >
                                              <TextField
                                                select
                                                size="small"
                                                fullWidth
                                                className={classes.textField}
                                                InputProps={{
                                                  // readOnly: true,
                                                  sx: {
                                                    fontSize: 14,
                                                    border: "none",
                                                  },
                                                  classes: {
                                                    root: classes.textFieldQuoteNoBorder,
                                                    notchedOutline:
                                                      classes.notchedOutline,
                                                  },
                                                }}
                                                InputLabelProps={{
                                                  shrink: true,
                                                  sx: {
                                                    fontSize: 14,
                                                    border: "none",
                                                  },
                                                }}
                                                value={adjustment.selector}
                                                onChange={(e) =>
                                                  handleAdjustmentChange(
                                                    index,
                                                    "selector",
                                                    e.target.value
                                                  )
                                                }
                                              >
                                                <MenuItem value="add">
                                                  Add
                                                </MenuItem>
                                                <MenuItem value="remove">
                                                  Remove
                                                </MenuItem>
                                              </TextField>
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              sx={{ width: "25%" }}
                                              className={classes.tablCellPayroll}
                                            >
                                              <TextField
                                                placeholder="Amount"
                                                size="small"
                                                value={adjustment.value}
                                                onChange={(e) =>
                                                  handleAdjustmentChange(
                                                    index,
                                                    "value",
                                                    parseFloat(e.target.value)
                                                  )
                                                }
                                                type="number"
                                                className={classes.textField}
                                                InputProps={{
                                                  // readOnly: true,
                                                  sx: {
                                                    fontSize: 14,
                                                    border: "none",
                                                  },
                                                  classes: {
                                                    root: classes.textFieldQuoteNoBorder,
                                                    notchedOutline:
                                                      classes.notchedOutline,
                                                  },
                                                }}
                                                InputLabelProps={{
                                                  sx: {
                                                    fontSize: 14,
                                                    border: "none",
                                                  },
                                                }}
                                              />
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              sx={{ width: "5%" }}
                                              className={classes.tablCellPayroll}
                                            >
                                              <Grid
                                                container
                                                spacing={1}
                                                sx={{
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                }}
                                              >
                                                <Grid item>
                                                  <IconButton
                                                    color="error"
                                                    onClick={() =>
                                                      removeAdjustment(index)
                                                    }
                                                  >
                                                    <FaTrash />
                                                  </IconButton>
                                                </Grid>
                                              </Grid>
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                py={2}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  startIcon={<AddIcon />}
                                  className={classes.addButton}
                                  onClick={addAdjustment}
                                >
                                  Add
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* )} */}
                      {editData && editData.edited_reason && (
                        <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            sx={{ py: 2, px: 5 }}
                            spacing={2}
                          >
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className={classes.backgroundColorView2}
                              sx={{ py: 3, px: 3, minHeight: "150px" }}
                            >
                              <Grid container>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    <span className={classes.customerDetails}>
                                      Note
                                    </span>{" "}
                                  </Typography>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Typography>
                                    {editData?.edited_reason || ""}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          sx={{ py: 2, px: 5 }}
                          spacing={2}
                        >
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2}>
                              <Grid item lg={6} md={6}></Grid>

                              <Grid
                                item
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                                className={classes.cardGreenBAckGroundColor}
                              >
                                <Grid container spacing={2}>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Grid container spacing={2}>
                                      <Grid
                                        item
                                        lg={8}
                                        md={8}
                                        sm={8}
                                        xs={8}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-start",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Typography
                                          className={classes.cardGreenTypograpy}
                                        >
                                          Normal Working Amount (
                                          {Number(
                                            editData?.total_normal_hours || 0
                                          ).toFixed(2)}
                                          {" hrs * $"}
                                          {Number(
                                            editData?.hourly_salary || 0
                                          ).toFixed(2)}
                                          )
                                        </Typography>
                                      </Grid>

                                      <Grid
                                        item
                                        lg={4}
                                        md={4}
                                        sm={4}
                                        xs={4}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          alignItems: "center",
                                        }}
                                        paddingRight={2}
                                      >
                                        <Typography
                                          className={classes.cardGreenTypograpy}
                                        >
                                          {"$ "}
                                          {Number(
                                            Number(
                                              editData?.total_normal_hours || 0
                                            ) *
                                              Number(
                                                editData?.hourly_salary || 0
                                              )
                                          ).toFixed(2)}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Grid container spacing={2}>
                                      <Grid
                                        item
                                        lg={8}
                                        md={8}
                                        sm={8}
                                        xs={8}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-start",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Typography
                                          className={classes.cardGreenTypograpy}
                                        >
                                          OT Amount (
                                          {Number(
                                            editData?.total_ot_hours || 0
                                          ).toFixed(2)}
                                          {" hrs * $"}
                                          {Number(
                                            editData?.ot_hourly_salary || 0
                                          ).toFixed(2)}
                                          )
                                        </Typography>
                                      </Grid>

                                      <Grid
                                        item
                                        lg={4}
                                        md={4}
                                        sm={4}
                                        xs={4}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          alignItems: "center",
                                        }}
                                        paddingRight={2}
                                      >
                                        <Typography
                                          className={classes.cardGreenTypograpy}
                                        >
                                          {"$ "}
                                          {Number(
                                            Number(
                                              editData?.total_ot_hours || 0
                                            ) *
                                              Number(
                                                editData?.ot_hourly_salary || 0
                                              )
                                          ).toFixed(2)}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Grid container spacing={2}>
                                      <Grid
                                        item
                                        lg={8}
                                        md={8}
                                        sm={8}
                                        xs={8}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-start",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Typography
                                          className={classes.cardGreenTypograpy}
                                        >
                                          Adjustment Amount
                                        </Typography>
                                      </Grid>

                                      <Grid
                                        item
                                        lg={4}
                                        md={4}
                                        sm={4}
                                        xs={4}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          alignItems: "center",
                                        }}
                                        paddingRight={2}
                                        pb={1}
                                        borderBottom={0.5}
                                      >
                                        <Typography
                                          className={classes.cardGreenTypograpy}
                                        >
                                          {"$ "}
                                          {Number(
                                            editData?.bonus_amount || 0
                                          ).toFixed(2)}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    py={2}
                                  >
                                    <Grid container spacing={2}>
                                      <Grid
                                        item
                                        lg={8}
                                        md={8}
                                        sm={8}
                                        xs={8}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-start",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Typography className={classes.h4}>
                                          Total Amount
                                        </Typography>
                                      </Grid>

                                      <Grid
                                        item
                                        lg={4}
                                        md={4}
                                        sm={4}
                                        xs={4}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          alignItems: "center",
                                        }}
                                        paddingRight={2}
                                      >
                                        <Typography className={classes.h4}>
                                          {"$ "}
                                          {Number(
                                            editData?.total_salary || 0
                                          ).toFixed(2)}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          sx={{ py: 2, px: 5 }}
                          spacing={2}
                        >
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container>
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Button
                                  variant="outlined"
                                  startIcon={<CloseIcon />}
                                  className={classes.addButton}
                                  onClick={handleEditClose}
                                >
                                  Cancel
                                </Button>{" "}
                                <Box m={0.5}></Box>
                                <Button
                                  variant="contained"
                                  startIcon={<SaveAltIcon />}
                                  className={classes.addButton}
                                  onClick={handleEditSave}
                                >
                                  Save
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-describedby="alert-dialog-description"
        classes={{ paper: "inherit" }}
        fullScreen={isMobile}
        fullWidth={isMobile}
        maxWidth="lg"
      >
        <Grid className={classes.Dialog}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Employee Payroll Details
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          {selectedName}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={8}
                        xs={8}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Grid
                          container
                          spacing={1}
                          justifyContent="flex-end"
                          sx={{ display: "flex" }}
                        >
                          <Grid item>
                            <Button
                              startIcon={<LocalPrintshopSharpIcon />}
                              className={classes.addButtonPdfExcel}
                              onClick={handleEmployeePunchExcel}
                            >
                              Excel
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              startIcon={<LocalPrintshopSharpIcon />}
                              className={classes.addButtonPdfExcel}
                              onClick={handleExportToPDFForEmployeePunch}
                            >
                              pdf
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell className={classes.tablheaderPayroll}>
                                  <strong>Date</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "left" }}
                                >
                                  <strong>Records</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Actual Hours</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Total Break Hours</strong>
                                </TableCell>

                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Total working hours</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Hourly Salary</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Total Amount</strong>
                                </TableCell>
                                {/* <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  <strong>Actions</strong>
                                </TableCell> */}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {payRollAnEmployeeLoading || positionLoading ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      alignItems="center"
                                      height="10vh"
                                    >
                                      <CircularProgress />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : payRollAnEmployeeIsError ||
                                EmployeePunchRecord.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    {isError
                                      ? "Error fetching data"
                                      : "No data available"}
                                  </TableCell>
                                </TableRow>
                              ) : (
                                EmployeePunchRecord.map(
                                  (row: IEmployeePunchRecord, index) => (
                                    <TableRow
                                      key={row.id}
                                      className={classes.tableRowHover}
                                    >
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                      >
                                        {dayjs(row.recordDate).format(
                                          "YYYY-MM-DD"
                                        )}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "left" }}
                                      >
                                        {row.punchDetails.length > 0 ? (
                                          row.punchDetails.map(
                                            (punchDetail, index) => {
                                              const punchInTime = formatTime(
                                                punchDetail.punch_in_time
                                              );
                                              const punchOutTime =
                                                punchDetail.punch_out_time
                                                  ? punchDetail.punch_in_date !==
                                                    punchDetail.punch_out_date
                                                    ? `${dayjs(
                                                        punchDetail.punch_out_date
                                                      ).format(
                                                        "MMM-DD, YYYY"
                                                      )} ${formatTime(
                                                        punchDetail.punch_out_time
                                                      )}`
                                                    : formatTime(
                                                        punchDetail.punch_out_time
                                                      )
                                                  : "Pending";

                                              return (
                                                <span key={index}>
                                                  {punchInTime} - {punchOutTime}
                                                  {index !==
                                                    row.punchDetails.length -
                                                      1 && ", "}
                                                </span>
                                              );
                                            }
                                          )
                                        ) : (
                                          <span> </span>
                                        )}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {row.break_hours === null ||
                                        row.total_hours === null ||
                                        isNaN(
                                          parseFloat(String(row.break_hours))
                                        ) ||
                                        isNaN(
                                          parseFloat(String(row.total_hours))
                                        )
                                          ? ""
                                          : parseFloat(
                                              String(row.break_hours)
                                            ) +
                                              parseFloat(
                                                String(row.total_hours)
                                              ) ===
                                            0
                                          ? "-"
                                          : `${(
                                              parseFloat(
                                                String(row.break_hours)
                                              ) +
                                              parseFloat(
                                                String(row.total_hours)
                                              )
                                            ).toFixed(2)} hrs`}
                                      </TableCell>

                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {row.break_hours === null ||
                                        isNaN(
                                          parseFloat(String(row.break_hours))
                                        )
                                          ? ""
                                          : parseFloat(
                                              String(row.break_hours)
                                            ) === 0
                                          ? "-"
                                          : `${parseFloat(
                                              String(row.break_hours)
                                            ).toFixed(2)} hrs`}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {row.total_hours === null ||
                                        isNaN(
                                          parseFloat(String(row.total_hours))
                                        )
                                          ? ""
                                          : parseFloat(
                                              String(row.total_hours)
                                            ) === 0
                                          ? "-"
                                          : `${parseFloat(
                                              String(row.total_hours)
                                            ).toFixed(2)} hrs`}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {selectedHrs === null ||
                                        isNaN(parseFloat(String(selectedHrs)))
                                          ? ""
                                          : parseFloat(String(selectedHrs)) ===
                                            0
                                          ? "-"
                                          : `$ ${parseFloat(
                                              String(selectedHrs)
                                            ).toFixed(2)}`}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "right" }}
                                      >
                                        {selectedHrs === null ||
                                        row.total_hours === null ||
                                        isNaN(
                                          parseFloat(String(selectedHrs)) *
                                            row.total_hours
                                        )
                                          ? ""
                                          : parseFloat(String(selectedHrs)) *
                                              row.total_hours ===
                                            0
                                          ? "-"
                                          : `$ ${(
                                              parseFloat(String(selectedHrs)) *
                                              row.total_hours
                                            ).toFixed(2)}`}
                                      </TableCell>
                                      {/* <TableCell className={classes.tablCellPayroll}>
                                    <Grid
                                      container
                                      spacing={1}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Grid item>
                                        <Button
                                          // variant="contained"
                                          className={classes.editButtonList}
                                          onClick={() =>
                                            handleDateViewClick(
                                              String(row.recordDate)
                                            )
                                          }
                                        >
                                          <VisibilitySharpIcon
                                            className={classes.editListIcon}
                                          />
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </TableCell> */}
                                    </TableRow>
                                  )
                                )
                              )}

                              <TableRow className={classes.tableRowHover}>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                ></TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "left" }}
                                ></TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                ></TableCell>

                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  {coursingToDelete &&
                                  coursingToDelete.total_break_hours !== null &&
                                  !isNaN(
                                    parseFloat(
                                      String(coursingToDelete.total_break_hours)
                                    )
                                  )
                                    ? parseFloat(
                                        String(
                                          coursingToDelete.total_break_hours
                                        )
                                      ) === 0
                                      ? "-"
                                      : `${parseFloat(
                                          String(
                                            coursingToDelete.total_break_hours
                                          )
                                        ).toFixed(2)} hrs`
                                    : ""}
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  {coursingToDelete &&
                                  coursingToDelete.total_hours !== null &&
                                  !isNaN(
                                    parseFloat(
                                      String(coursingToDelete.total_hours)
                                    )
                                  )
                                    ? parseFloat(
                                        String(coursingToDelete.total_hours)
                                      ) === 0
                                      ? "-"
                                      : `${parseFloat(
                                          String(coursingToDelete.total_hours)
                                        ).toFixed(2)} hrs`
                                    : ""}
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                ></TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCellPayroll}
                                  sx={{ textAlign: "right" }}
                                >
                                  {coursingToDelete &&
                                  coursingToDelete.gross_salary !== null &&
                                  !isNaN(
                                    parseFloat(
                                      String(coursingToDelete.gross_salary)
                                    )
                                  )
                                    ? parseFloat(
                                        String(coursingToDelete.gross_salary)
                                      ) === 0
                                      ? "-"
                                      : `$ ${parseFloat(
                                          String(coursingToDelete.gross_salary)
                                        ).toFixed(2)}`
                                    : ""}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={openAdminConfim}
        onClose={() => setOpenAdminConfim(false)}
        sx={{ padding: 5, minWidth: 450 }}
      >
        <Grid className={classes.Dialog}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Employee Payroll Date Details
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell className={classes.tablheaderPayroll}>
                                  <strong>Date</strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheaderPayroll}
                                  sx={{ textAlign: "center" }}
                                >
                                  <strong>Time Range</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {payRollEachEmployeeLoading ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      alignItems="center"
                                      height="10vh"
                                    >
                                      <CircularProgress />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : payRollEachEmployeeIsError ||
                                EmployeePunchRecord.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    {isError
                                      ? "Error fetching data"
                                      : "No data available"}
                                  </TableCell>
                                </TableRow>
                              ) : (
                                EmpEachPunchRecord.map(
                                  (row: IPayrollEachEmployeDateList, index) => (
                                    <TableRow
                                      key={row.id}
                                      className={classes.tableRowHover}
                                    >
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                      >
                                        {dayjs(row.punch_in_date).format(
                                          "YYYY-MM-DD"
                                        )}
                                      </TableCell>
                                      <TableCell
                                        scope="row"
                                        className={classes.tablCellPayroll}
                                        sx={{ textAlign: "center" }}
                                      >
                                        {formatTime(row.punch_in_time)} -{" "}
                                        {formatTime(row.punch_out_time)}
                                      </TableCell>
                                    </TableRow>
                                  )
                                )
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={() => handleDialogCloseAdminConform(false)}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={openAdminConfimPayroll}
        onClose={() => setOpenAdminConfimPayroll(false)}
        sx={{ padding: 5, minWidth: 450 }}
      >
        <Grid className={classes.Dialog}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              pt={2}
              alignContent={"center"}
            >
              <Typography className={classes.cardTitle}>
                Edit Payroll
              </Typography>
            </Grid>
          </Grid>
          <DialogContent>
            <DialogContentText sx={{ pt: 3 }}>
              Are you sure you want to edit payroll?
              {newEmployeeDataIsLoading && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="10vh"
                >
                  <CircularProgress />
                </Box>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              className={classes.addButton}
              onClick={() => handleDialogCloseAdminPayrollConform(false)}
            >
              Cancel
            </Button>
            <Box m={0.5}></Box>
            {userHasRight(Privileges.GeneratePayroll) && (
              <Button
                onClick={() => handleDialogAdminConform(true)}
                variant="contained"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={18} className={classes.isLoading} />
                  ) : (
                    <CheckCircleOutlineIcon />
                  )
                }
                className={classes.addButton}
              >
                Confirm
              </Button>
            )}
          </DialogActions>
        </Grid>
      </Dialog>
    </div>
  );
};

export default Index;
